import { create } from "zustand";

/**
 * State interface for order search functionality
 */
interface OrderSearchState {
  /** The currently searched order number */
  matchCount: number;
  setMatchCount: (count: number) => void;
  searchedOrderNumber: string;

  /** Sets the current order number search term */
  setSearchedOrderNumber: (orderNumber: string) => void;

  /** Clears the current search */
  clearSearch: () => void;
}

/**
 * Store for managing order search state across components
 */
export const useOrderSearchStore = create<OrderSearchState>((set) => ({
  matchCount: 0,
  searchedOrderNumber: "",

  setSearchedOrderNumber: (orderNumber: string) =>
    set({ searchedOrderNumber: orderNumber }),

  clearSearch: () => set({ searchedOrderNumber: "" }),
  setMatchCount: (count: number) => set({ matchCount: count }),
}));
